export default __webpack_public_path__ + "static/Quickinstallation_03-ebc4bb8082660416dfe5d8680f99634d.webp";